import React from 'react';
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from '../redux/store';

type Props = {
  children: React.ReactNode,
  redirect?:string
}

const PublicRouteOwner: React.FC<Props> = ({ children,redirect }) => {
  const accessToken = useSelector((state: RootState) => state.owner.accessToken);
    const storeToken = useSelector((state: RootState) => state.store.accessToken);


  // إذا يوجد token → إعادة التوجيه
  if (accessToken || storeToken) {
    return <Navigate to={redirect?redirect: "/store/dashboard"} replace />;
  }

  return <>{children}</>;
}

export default PublicRouteOwner;
